// En local: crea TripTick/.env con REACT_APP_API_URL=http://localhost:5001 (o el puerto de tu API) y reinicia npm.
// Sin eso, las peticiones van a Vercel aunque tengas el backend levantado en tu máquina.
export const BASEURL =
  process.env.REACT_APP_API_URL || "https://triptickbackend.vercel.app";
